import { ReduceStore } from 'flux/utils';
import { Map } from 'immutable';
import AppDispatcher from '../AppDispatcher';
import CrossChannelRunStore from './CrossChannelRunStore';
import CrossChannelScenarioStore from './CrossChannelScenarioStore';
import CurrentOrganizationIdStore from './CurrentOrganizationIdStore';

import { determineMostRecentRun,
         runningJobStatuses,
         completedJobStatuses,
         determineStatus,
         sortScenarios,
       } from './util/CrossChannelHelpers';

class CrossChannelIndexStore extends ReduceStore {
  getInitialState() {
    return new Map();
  }

  reduce(state) {
    this.getDispatcher().waitFor([
      CrossChannelScenarioStore.getDispatchToken(),
      CrossChannelRunStore.getDispatchToken(),
      CurrentOrganizationIdStore.getDispatchToken()]);

    if (CrossChannelScenarioStore.hasChanged() ||
        CrossChannelRunStore.hasChanged() ||
        CurrentOrganizationIdStore.hasChanged()) {
      const scenarios = CrossChannelScenarioStore.getScenarios();
      const runs = CrossChannelRunStore.getRuns();
      const organizationId = CurrentOrganizationIdStore.getOrganizationId();

      const scenariosWithRuns = scenarios.map((scenario) => {
        const lastRun = determineMostRecentRun(runs, scenario.id);
        const scenarioWithRun = {
          ...scenario,
          lastRun,
          status: determineStatus(lastRun),
        };
        return scenarioWithRun;
      });

      return { organizationId, scenarios: new Map(scenariosWithRuns) };
    }

    return state;
  }

  getRunningScenarios() {
    const orgId = this.getState().organizationId;
    const scenarios = (this.getState().scenarios || new Map())
      .filter(scenario => runningJobStatuses.includes(scenario.status) &&
                          scenario.organizationId === orgId);
    return sortScenarios(scenarios);
  }

  getCompletedScenarios() {
    const orgId = this.getState().organizationId;
    const scenarios = (this.getState().scenarios || new Map())
      .filter(scenario => completedJobStatuses.includes(scenario.status) &&
                          scenario.organizationId === orgId);
    return sortScenarios(scenarios);
  }

  // Assume that anything without a run is a draft
  getDraftScenarios() {
    const orgId = this.getState().organizationId;
    const scenarios = (this.getState().scenarios || new Map())
      .filter(scenario => scenario.status === 'draft' &&
                          scenario.organizationId === orgId);
    return sortScenarios(scenarios);
  }

  getOrganizationId() {
    return this.getState().organizationId;
  }

  getScenario(scenarioId) {
    const orgId = this.getState().organizationId;
    const currentScenario = (this.getState().scenarios || new Map())
      .find(scenario => scenario.id === scenarioId &&
                        scenario.organizationId === orgId);

    return currentScenario;
  }
}

const instance = new CrossChannelIndexStore(AppDispatcher);
export default instance;
